import axios from 'axios'
const Axios = {
  install: function (Vue, options) {
    Vue.prototype.$axios = axios
  }
}
export default Axios
